export class ReqModelMatchedBills {
    tenant_id: number;
    monthly_posting_id: number;

    constructor(tenant_id: number, monthly_posting_id: number) {
        if (tenant_id != null) { this.tenant_id = tenant_id; }
        if (monthly_posting_id != null) { this.monthly_posting_id = monthly_posting_id; }
    }
}